// SPDX-License-Identifier: AGPL-3.0-or-later

export interface VideoDimensions {
	width: number;
	height: number;
}

export function normalizeVideoDimensions(dimensions?: Partial<VideoDimensions> | null): VideoDimensions | null {
	const width = dimensions?.width;
	const height = dimensions?.height;
	if (!Number.isFinite(width) || !Number.isFinite(height) || !width || !height || width <= 0 || height <= 0) {
		return null;
	}
	return {
		width: Math.round(width),
		height: Math.round(height),
	};
}

export function hasDifferentAspectRatio(
	currentDimensions: VideoDimensions,
	nextDimensions: VideoDimensions,
	tolerance = 0.01,
): boolean {
	const currentRatio = currentDimensions.width / currentDimensions.height;
	const nextRatio = nextDimensions.width / nextDimensions.height;
	if (!Number.isFinite(currentRatio) || !Number.isFinite(nextRatio)) {
		return false;
	}
	return Math.abs(currentRatio - nextRatio) / currentRatio > tolerance;
}
